import createLightTheme from '@nykaa/ui-components/themes/lightTheme/createLightTheme';
import { theme as lightTokens } from 'shared/styles/theme/fashionTheme';
import { config as darkTokens } from 'shared/styles/theme/darkTheme';
import { theme as footlockerTokens } from 'shared/styles/theme/footlockerTheme';
import createTheme, { THEME_MODES } from '@nykaa/glam-pallete-web/dist/utils/createTheme';

const themeMap = {
  light: {
    tokens: lightTokens,
    lumiTheme: THEME_MODES.MOCHA_GLOW,
    componentTokens: {
      reviewCTA: {
        background: 'transparent',
        color: '#1a1a1a',
        border: '1px solid rgba(0,0,0,0.16)',
      },
    },
  },
  dark: {
    tokens: darkTokens,
    lumiTheme: THEME_MODES.MOCHA_GLOW_DARK,
    componentTokens: {
      reviewCTA: {
        background: '#ffffff',
        color: '#000000',
        border: 'none',
      },
    },
  },
  footlocker: {
    tokens: footlockerTokens,
    lumiTheme: THEME_MODES.MOCHA_GLOW,
    componentTokens: {
      reviewCTA: {
        background: 'transparent',
        color: '#000000',
        border: '1px solid rgba(0,0,0,0.16)',
      },
    },
  },
};

export const getAppTheme = (themeName?: string) => {
  const entry =
    themeMap[process.env.DOMAIN_NAME as keyof typeof themeMap] ??
    themeMap[themeName as keyof typeof themeMap] ??
    themeMap.light;

  // @ts-expect-error - buttonBorderRadius is a custom property not in UI components Borders type
  const defaultTheme = createLightTheme(entry.tokens);
  const theme = createTheme(defaultTheme, entry.lumiTheme);

  return { ...theme, componentTokens: entry.componentTokens };
};

export type AppTheme = ReturnType<typeof getAppTheme>;
